// Lo que sale del catálogo (ADR-2026-10-15-el-catalogo-se-descarga-y-se-lanza): las fotos que ya
// salieron, con el producto y la toma de cada una, para bajarlas en UN zip o mandarlas a un
// lanzamiento. Puro.
import type { ImagenParaLanzamiento } from '../../../../components/EnviarALanzamiento';
import type { PlanDeCatalogo } from './plan';

export interface FotoDelCatalogo {
  imageId: string;
  varianteId: string;
  /** "Silla Oslo/Ambiente 2.jpg": una carpeta por producto adentro del zip
   *  (ADR-2026-10-15-el-zip-del-catalogo-va-por-carpetas). La extensión real la corrige
   *  `descargarComoZip` por los bytes. */
  nombre: string;
}

/** Lo que un sistema de archivos no acepta en un nombre, y los espacios de más. */
export const limpiar = (s: string): string =>
  s
    .replace(/[\\/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

/** `base`, o "base (2)", "base (3)"… el primero que no está en `usados` (sin distinguir
 *  mayúsculas, como los sistemas de archivos de Mac y Windows). Lo anota. */
export function nombreLibre(base: string, usados: Set<string>): string {
  let nombre = base;
  for (let n = 2; usados.has(nombre.toLowerCase()); n++) nombre = `${base} (${n})`;
  usados.add(nombre.toLowerCase());
  return nombre;
}

/** Todas las fotos que ya salieron, en el orden del plan (producto por producto, toma por toma). */
export function fotosDelCatalogo(plan: PlanDeCatalogo): FotoDelCatalogo[] {
  const titulos = new Map(plan.tomas.map((t) => [t.id, t.titulo]));
  // Dos productos con el mismo nombre no comparten carpeta (el segundo es "Nombre (2)"), aunque
  // otro producto se llame justo "Nombre (2)". Lo mismo con dos tomas de igual título.
  const carpetas = new Set<string>();
  const out: FotoDelCatalogo[] = [];
  for (const p of plan.productos) {
    if (!p.items.some((it) => it.imageIds?.length)) continue;
    const carpeta = nombreLibre(limpiar(p.nombre) || 'Producto', carpetas);
    const archivos = new Set<string>();
    for (const it of p.items) {
      const ids = it.imageIds ?? [];
      ids.forEach((imageId, i) => {
        const toma = limpiar(titulos.get(it.tomaId) ?? it.tomaId) || 'Foto';
        const archivo = nombreLibre(`${toma}${ids.length > 1 ? ` ${i + 1}` : ''}`, archivos);
        out.push({ imageId, varianteId: p.varianteId, nombre: `${carpeta}/${archivo}.jpg` });
      });
    }
  }
  return out;
}

export const nombreDelZip = (titulo: string): string => `${limpiar(titulo) || 'catalogo'}.zip`;

/** Para "Publicar en tu tienda online": cada foto con la variante de SU producto, que la fila de
 *  la creación no guarda (el lote del agente genera sin `variante_id`). */
export const paraLanzamiento = (fotos: readonly FotoDelCatalogo[]): ImagenParaLanzamiento[] =>
  fotos.map((f) => ({ id: f.imageId, variante_id: f.varianteId }));
